import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./app/Store";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import i18n from "./translations/i18n";
import { UnsavedChangesProvider } from "./feature/UnsavedChangesProvider";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <UnsavedChangesProvider>
        <App />
      </UnsavedChangesProvider>
    </Provider>
  </I18nextProvider>

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
